export default __webpack_public_path__ + "static/media/P20-Tip-Solution-Blue.28074352.svg";